import React, { useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomerManagementList from "../../../Screens/Customers/CustomerManagementList";
import { Doughnut } from "react-chartjs-2";
import "../../../styles/admin-panel.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  LineController,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardDataRequest } from "../../../redux/Dashboard/DashboardAction";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const DashboardPage = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(fetchDashboardDataRequest());
  }, [dispatch]);

  const userRolesData = {
    labels: ["Admins", "Staffs", "Vendors"],
    datasets: [
      {
        data: [
          data?.count?.staffsCount || 0,
          data?.count?.usersCount || 0,
          data?.count?.vendorsCount || 0,
        ],
        backgroundColor: ["#4CAF50", "#FF9800", "#03A9F4"],
        hoverBackgroundColor: ["#45D659", "#FFC947", "#1E88E5"],
      },
    ],
  };

  const leadsData = {
    labels: ["Leads", "Bookings"],
    datasets: [
      {
        data: [
          data?.count?.totalBookingCount || 0,
          data?.count?.todayBookingCount || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB"],
      },
    ],
  };

  const statisticsData = [
    // { metric: "Total Revenue", value: "$45,678", change: "+20%" },
    { metric: "Total Users", value: data?.count?.usersCount || 0 },
    {
      metric: "Total Bookings",
      value: data?.count?.totalBookingCount || 0,
    },
    {
      metric: "Today Cancellations",
      value: data?.count?.todayCancelBookingCount || 0,
    },
  ];

  return (
    <Box className="admin-panel-box">
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Total Users
                </Typography>
                <Typography variant="h4" className="metric-value-users">
                  {data?.count?.usersCount +
                    data?.count?.staffsCount +
                    data?.count?.vendorsCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Admins: {data?.count?.usersCount || 0}, Staffs:{" "}
                  {data?.count?.staffsCount || 0}, Vendors:{" "}
                  {data?.count?.vendorsCount || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Divider className="divider-line" />

          <Grid item xs={12} sm={6} md={3}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Leads Generated
                </Typography>
                <Typography variant="h4" className="metric-value-Leads">
                  {data?.count?.todayBookingCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Conversion Rate: 30%
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Total Revenue
                </Typography>
                <Typography variant="h4" className="metric-value-revenue">
                  ₹45,678
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Monthly Growth: 20%
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Payments
                </Typography>
                <Typography variant="h4" className="metric-value-payments">
                  {data?.count?.totalBookingCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Refunds: {data?.count?.totalCancelBookingCount || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider className="divider-line" />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card className="dashboard-card">
            <CardContent className="dashboard-card-content">
              <Box className="dashboard-header">
                <Typography variant="h6" className="dashboard-title">
                  User Roles Overview
                </Typography>
              </Box>
              <Box className="dashboard-chart-container">
                <Doughnut
                  data={userRolesData}
                  options={{
                    maintainAspectRatio: false,
                    responsive: true,
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="dashboard-card">
            <CardContent className="dashboard-card-content">
              <Box className="dashboard-header">
                <Typography variant="h6" className="dashboard-title">
                  Leads vs Bookings
                </Typography>
              </Box>
              <Box className="dashboard-chart-container">
                <Doughnut
                  data={leadsData}
                  options={{
                    maintainAspectRatio: false,
                    responsive: true,
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider className="divider-line" />

      <CustomerManagementList />

      <Divider className="divider-line" />

      <Grid container spacing={3}>
        {/* Booking Management */}
        <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: 5 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Booking Management
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Bookings: {data?.count?.totalBookingCount || 0}
              </Typography>

              <Typography variant="body2" color="textSecondary">
                Total Cancellations: {data?.count?.totalCancelBookingCount || 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Completed Bookings:{" "}
                {data?.count?.totalCompletedBookingCount || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Vendor Management */}
        <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: 5 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Vendor Management
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Pending Approvals: 3
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Discounts Applied: 10%
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Vendors: {data?.count?.vendorsCount || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider className="divider-line" />

      <Typography variant="h5" gutterBottom>
        Statistics Reports
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Metric</TableCell>
            <TableCell align="center">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statisticsData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.metric}</TableCell>
              <TableCell align="center">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
export default DashboardPage;
